import { useEffect, useState, useCallback } from "react";
import { Capacitor } from "@capacitor/core";
import { useConfig } from "../providers/config";
import { useUpdateNotificationStore } from "../providers/updateNotification";
import { App as AppPlugin } from "@capacitor/app";
import { toast } from "react-toastify";

const useUpdateNotification = () => {
  const config = useConfig();
  const { shouldShow, dismiss } = useUpdateNotificationStore();
  const [isOpen, setIsOpen] = useState(false);
  const [hasNewerVersion, setHasNewerVersion] = useState(false);

  const isIOS = Capacitor.getPlatform() === "ios";
  const isUpdateNotificationEnabled = config.isUpdateNotificationEnabled;
  const latestVersion = isIOS ? config.latestIosVersion : config.latestAndroidVersion; // 1.68

  useEffect(() => {
    const getAppInfo = async () => {
      if (!Capacitor.isNativePlatform()) return;
      if (!shouldShow()) return;
      if (!isUpdateNotificationEnabled) return;

      const appInfo = await AppPlugin.getInfo(); // 1.65
      toast.info(`appInfo.version: ${appInfo.version}`);
      const hasNewerVersion = !!latestVersion && Number(appInfo.version) < Number(latestVersion);
      toast.info(`latestVersion: ${latestVersion}`);

      setHasNewerVersion(hasNewerVersion);
      if (!hasNewerVersion) return;

      setIsOpen(true);
    };

    getAppInfo();
  }, [isUpdateNotificationEnabled, latestVersion, shouldShow]);

  const open = useCallback(() => setIsOpen(true), []);

  const close = useCallback(() => {
    setIsOpen(false);
    dismiss();
  }, [dismiss]);

  return {
    isOpen,
    open,
    close,
    hasNewerVersion,
  };
};

export default useUpdateNotification;
